import React from "react";
import "../attention.css";

const Attention = () => {
  return (
    <div className="attention">
      <div className="title-screen">
        <h1 className="a-header">CAFES IN SEATTLE</h1>
      </div>

      <div className="page">
        <div className="cafe-section">
          <div className="cafe-details">
            <h2 className="cafe-name">RETREAT</h2>
            <h3 className="location"> Greenlake</h3>
            <p className="description">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin vel
              odio eu arcu ultrices lacinia.
            </p>
          </div>
          <img
            src="/images/retreat.png"
            alt="Retreat Cafe"
            className="cafe-img"
          />
        </div>
        
        <div className="cafe-section">
          <div className="cafe-details">
            <h2 className="cafe-name">CAFE HAGEN</h2>
            <h3 className="location"> South Lake Union</h3>
            <p className="description">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin vel
              odio eu arcu ultrices lacinia.
            </p>
          </div>
          <img
            src="/images/hagen.png"
            alt="Cafe Hagen"
            className="cafe-img"
          />
        </div>
        
        <div className="cafe-section">
          <div className="cafe-details">
            <h2 className="cafe-name">TOP POT DOUGHNUTS</h2>
            <h3 className="location"> Edmonds</h3>
            <p className="description">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin vel
              odio eu arcu ultrices lacinia.
            </p>
          </div>
          <img
            src="/images/top.png"
            alt="Top Pot Doughnuts"
            className="cafe-img"
          />
        </div>
      </div>
    </div>
  );
};

export default Attention;